import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import GameAbstract from '../core/GameAbstract';
import Template from 'frontools/data/Template';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import NumberUtils from 'frontools/utils/NumberUtils';
import { GameMode, GameManager } from '../core/GameManager';
import { GameEvent } from '../core/GameAbstract';
import Breakpoint from 'frontools/core/Breakpoint';

declare var dataLayer           : any;

export class Bastasiesta extends GameAbstract {

    public static instance                  : Bastasiesta;

    public static CLICK                     : string                        = 'click';
    public static TAP                       : string                        = 'tap';

    private _mask                           : PIXI.Graphics;
    private _buttonsContainer               : PIXI.Container;
    
    private _buttonRight                    : PIXI.Container;
    private _buttonLeft                     : PIXI.Container;
    private _slothContainer                 : PIXI.Container;
    
    private _sloth                          : PIXI.extras.AnimatedSprite;
    private _mouth                          : PIXI.extras.AnimatedSprite;
    private _leftEye                        : PIXI.extras.AnimatedSprite;
    private _rightEye                       : PIXI.extras.AnimatedSprite;
    private _pokeLeft                       : PIXI.extras.AnimatedSprite;
    private _pokeRight                      : PIXI.extras.AnimatedSprite;
    private _zZz                            : PIXI.extras.AnimatedSprite;

    private _gameOn                         : boolean                        = true;
    private _clickEnable                    : boolean                        = true;

    private _closeChrono                    : number                         = 500;

    private _progress                       : number                         = 0;
    private _progressLeftEye                : number                         = 0;
    private _progressRightEye               : number                         = 0;
    private _totalProgress                  : number                         = 0;

    private _thisLevelBracket               : number                         = 1;
    private _lastLevelBracket               : number                         = 1;

    private _awakeSound                     : number                         = 1;
    private _pastySound                     : number                         = 1;
    private _pastyMouthPlaying              : boolean                        = false;


    constructor() {
        super({
            time: 20,
            results: [
                '0-100',
                '101-150',
                '151-9999'
            ],
            assets: [
                { name: 'sloth',    url: 'sprite/sloth.png' },
                { name: 'mouth',    url: 'sprite/mouth/mouth.json' },
                { name: 'leftEye',  url: 'sprite/leftEye/leftEye.json' },
                { name: 'rightEye', url: 'sprite/rightEye/rightEye.json' },
                { name: 'poke',     url: 'sprite/handPoke/poke.json' },
                { name: 'zZz',      url: 'sprite/zZz/zZz.json' },
                
                { name: 'pasty1',   url: 'audio/pasty_mouth/pasty_mouth_1.mp3' },
                { name: 'pasty2',   url: 'audio/pasty_mouth/pasty_mouth_2.mp3' },
                { name: 'pasty3',   url: 'audio/pasty_mouth/pasty_mouth_3.mp3' },
                { name: 'pasty4',   url: 'audio/pasty_mouth/pasty_mouth_4.mp3' },
                { name: 'pasty5',   url: 'audio/pasty_mouth/pasty_mouth_5.mp3' },
                { name: 'poke1',    url: 'audio/poke/poke_1.mp3' },
                { name: 'poke2',    url: 'audio/poke/poke_2.mp3' },
                { name: 'poke3',    url: 'audio/poke/poke_3.mp3' },
                { name: 'poke4',    url: 'audio/poke/poke_4.mp3' },
                { name: 'awake1',   url: 'audio/awake/awake_1.mp3' },
                { name: 'awake2',   url: 'audio/awake/awake_2.mp3' },
                { name: 'awake3',   url: 'audio/awake/awake_3.mp3' },
                { name: 'snore',    url: 'audio/snore.mp3' }
            ]
        });

        // Pseudo singleton
        Bastasiesta.instance = this;
    };


    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();
        
        this._sloth             = Assets.sprites['sloth'];
        this._mouth             = Assets.sprites['mouth'];
        this._leftEye           = Assets.sprites['leftEye'];
        this._rightEye          = Assets.sprites['rightEye'];
        this._pokeLeft          = Assets.sprites['poke'];
        this._pokeRight         = Assets.getSpriteFromJson('poke');
        this._zZz               = Assets.sprites['zZz'];

        this._buttonLeft        = this.createButton('left');           
        this._buttonRight       = this.createButton('right');
        this._buttonsContainer  = new PIXI.Container();
        this._buttonsContainer.addChild(this._buttonLeft);
        this._buttonsContainer.addChild(this._buttonRight);

        this._mask = this._drawRect(this._screenWidth, this._screenHeight);
    };


    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {

        this._slothContainer = new PIXI.Container();
        
        this._slothContainer.addChild(this._sloth);

        this._slothContainer.addChild(this._leftEye);
        this._leftEye.loop = false;
        this._leftEye.scale.x = 0.95;
        this._leftEye.scale.y = 0.95;
        this._leftEye.x = this._slothContainer.width  / 2 - this._leftEye.width * 1.85;
        this._leftEye.y = this._slothContainer.height  / 2 - this._leftEye.height * 1.95;

        this._slothContainer.addChild(this._rightEye);
        this._rightEye.loop = false;
        this._rightEye.scale.x = 0.95;
        this._rightEye.scale.y = 0.95;
        this._rightEye.x = this._slothContainer.width  / 2 + this._leftEye.width / 3;
        this._rightEye.y = this._slothContainer.height / 2 - this._rightEye.height * 1.95;

        this._slothContainer.addChild(this._mouth);
        this._mouth.loop = false;
        this._mouth.scale.x = 0.5;
        this._mouth.scale.y = 0.5;
        this._mouth.x = this._slothContainer.width / 2 - this._mouth.width / 1.4;
        this._mouth.y = this._slothContainer.height / 2 - this._mouth.height / 6;

        this._slothContainer.addChild(this._zZz);
        this._zZz.loop = true;
        this._zZz.scale.x = 0.95;
        this._zZz.scale.y = 0.95;
        this._zZz.x = this._slothContainer.width/ 2 - this._zZz.width / 1.6;
        this._zZz.y = this._slothContainer.height / 2 - this._zZz.height;
        this._zZz.play();
        this._zZz.animationSpeed = .5;
        
        this._stage.addChild(this._slothContainer);

        this._stage.addChild(this._pokeLeft);
        this._pokeLeft.pivot = new PIXI.Point(this._pokeRight.width / 2, this._pokeRight.height);
        this._pokeLeft.scale.x = -1;
        this._pokeLeft.loop = false;
        
        this._stage.addChild(this._pokeRight);
        this._pokeRight.pivot =  new PIXI.Point(this._pokeRight.width/2, this._pokeRight.height); 
        this._pokeRight.loop = false;

        this._stage.addChild(this._buttonsContainer);

        Assets.sounds['snore'].play();

        super._prepare(); 
    };


    /*
     * @core override
     * _start - Starts the game
     * 
     */
    protected _start() {
        super._start();

        this._buttonLeft.on(Bastasiesta.CLICK, this._doAwake, this);
        this._buttonRight.on(Bastasiesta.CLICK, this._doAwake, this);

        this._buttonLeft.on(Bastasiesta.TAP, this._doAwake, this);
        this._buttonRight.on(Bastasiesta.TAP, this._doAwake, this);

        // Call the degenerative method
        this._doSleep();
    };


    private _doSleep() {
        setTimeout(function() {
            this._progressLeftEye -= 5;
            this._progressRightEye -= 5;

            this._progressLeftEye = this._progressLeftEye < 0 ? 0 : this._progressLeftEye;
            this._progressRightEye = this._progressRightEye < 0 ? 0 : this._progressRightEye;

            if (this._totalProgress < 50) { this._closeChrono = 500; }
            if (this._totalProgress >= 50) { this._closeChrono = 400; }
            if (this._totalProgress >= 85) { this._closeChrono = 300; }

            this._renderExpressions();
            this._doSleep();

        }.bind(this), this._closeChrono);
    };

    private _doAwake(e) {
        let type = e.type,
            direction = e.target.name;

        if (this._clickEnable) {
            this._clickEnable = false;
            let timeout = setTimeout(() => { // enable click after delay
                this._clickEnable = true;
            }, 80);

            if (type == 'click') {  this._progress = 5;  } 
            else {  this._progress = 4; }

            if (direction === 'left' || e.keyCode === 37) {
                this._pokeLeft.gotoAndPlay(1);
                this._progressLeftEye += this._progress;
                this._progressLeftEye = this._progressLeftEye > 100 ? 100 : this._progressLeftEye;
            } else if (direction === 'right' || e.keyCode === 39) {
                this._pokeRight.gotoAndPlay(1);
                this._progressRightEye += this._progress;
                this._progressRightEye = this._progressRightEye > 100 ? 100 : this._progressRightEye;
            }

            let sound = Math.floor(Math.random() * 4) + 1;
            Assets.sounds['poke' + sound].play();

            this._renderExpressions();
            this._updateScore();
        }
    }


    private _renderExpressions() {
        
        let leftProgress = Math.ceil(this._leftEye.totalFrames * this._progressLeftEye / 100);        
        this._leftEye.gotoAndStop(leftProgress <= 0 ? 0 : leftProgress - 1);

        let rightProgress = Math.ceil(this._rightEye.totalFrames * this._progressRightEye / 100);
        this._rightEye.gotoAndStop(rightProgress <= 0 ? 0 : rightProgress - 1);

        this._totalProgress = this._progressLeftEye + this._progressRightEye / 2;
        let mouthProgress  = Math.ceil(this._totalProgress * this._mouth.totalFrames / 100);

        if (mouthProgress > 23) mouthProgress = 23;
        this._mouth.gotoAndStop(mouthProgress);

        if (this._totalProgress > 30) this._zZz.visible = false;
        else this._zZz.visible = true;

        if (this._gameOn) {
            if (this._totalProgress < 30) {
                this._thisLevelBracket = 1;
                if (this._thisLevelBracket != this._lastLevelBracket) {
                    Assets.sounds['snore'].play();

                    Assets.sounds['pasty' + this._pastySound].stop();
                    this._lastLevelBracket = 1;
                }
            }

            if (this._totalProgress >= 30 && this._totalProgress < 90) {
                this._thisLevelBracket = 2;

                if (this._thisLevelBracket != this._lastLevelBracket) this._pastyMouthPlaying = false;

                if(this._pastyMouthPlaying == false) {

                    this._pastyMouthPlaying = true;
                    
                    this._pastySound = Math.floor(Math.random() * 5) + 1;
                    Assets.sounds['pasty' + this._pastySound].play();

                    setTimeout(function() {
                        Assets.sounds['pasty' + this._pastySound].stop();
                        this._pastyMouthPlaying = false;
                    }.bind(this), 2000);
                }
                
                Assets.sounds['snore'].stop();
                this._lastLevelBracket = 2;
            }
            
            if (this._totalProgress > 90) {
                this._thisLevelBracket = 3;
                if (this._thisLevelBracket != this._lastLevelBracket) {
                    this._awakeSound = Math.floor(Math.random() * 3) + 1;
                    Assets.sounds['awake' + this._awakeSound].play();

                    Assets.sounds['pasty' + this._pastySound].stop();
                    this._lastLevelBracket = 3;
                }
            }
        }
    }


    private _updateScore() {
        let score = this._totalProgress > 90 ? 3 : 1;
        this._gameScore.add(score);
    }


    private createButton(name: string) : PIXI.Container{
        var button = new PIXI.Container();
        button.addChild(this._drawRect(this._screenWidth, this._screenHeight, 0x617a72, 1));  
        button.alpha = 0; 
        button.name = name;
        button.x = (name === "left") ? 0 : this._screenWidth;
        button.y = 0;
        button.interactive = true;
        button.buttonMode = true;
        return button;  
    }


    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };


    /*
     * @core override
     * _onTimerComplete - on game timer complete handler
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        Assets.sounds['snore'].stop();
        Assets.sounds['pasty1'].stop();
        Assets.sounds['pasty2'].stop();
        Assets.sounds['pasty3'].stop();
        Assets.sounds['pasty4'].stop();
        Assets.sounds['pasty5'].stop();
        
        this._gameOn = false;

        super._onTimerComplete(e);
    };


    protected _end() {
        super._end();
    }


    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);

        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {

            let widthRatio = Breakpoint.isHigherThan('tablet') ? 1 : this._screenWidth / this._slothContainer.width;
            let heightRatio = Breakpoint.isHigherThan('tablet') ? 1 : this._screenHeight / this._slothContainer.height;

            if (widthRatio >= heightRatio) {
                this._slothContainer.width = this._slothContainer.width * widthRatio;
                this._slothContainer.height = this._slothContainer.height * widthRatio;
            } else if (heightRatio > widthRatio) {
                this._slothContainer.width = this._slothContainer.width * heightRatio;
                this._slothContainer.height = this._slothContainer.height * heightRatio;
            }

            this._slothContainer.x = this._screenWidth / 2 - this._slothContainer.width / 2;
            this._slothContainer.y = this._screenHeight / 2 - this._slothContainer.height / 2;

            this._pokeLeft.x = this._screenWidth / 4;
            this._pokeLeft.y = this._screenHeight + this._pokeLeft.height / 7;

            this._pokeRight.x = this._screenWidth / 1.25;
            this._pokeRight.y = this._screenHeight + this._pokeLeft.height / 7;

            // Resetting buttons width and height
            (this._buttonLeft.getChildAt(0)  as PIXI.Graphics).height = this._screenHeight;
            (this._buttonLeft.getChildAt(0)  as PIXI.Graphics).width = this._screenWidth/2;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).height = this._screenHeight;
            (this._buttonRight.getChildAt(0) as PIXI.Graphics).width = this._screenWidth/2;
            this._buttonRight.x = this._screenWidth/2;
        }
    };
}





